import React from 'react';
import parse from 'html-react-parser';
import Tippy from '@tippyjs/react'; // Import Tippy.js
import 'tippy.js/dist/tippy.css'; // Default Tippy styles
import 'tippy.js/animations/scale.css'; // Animation styles

import { FiInfo, FiCopy } from 'react-icons/fi';

interface InformativeTooltipProps {
  content: string;
  placement?: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end' | 'right' | 'right-start' | 'right-end';
  cursor?: 'auto' | 'default' | 'none' | 'context-menu' | 'help' | 'pointer' | 'progress' | 'wait' | 'cell' | 'crosshair' | 'text' | 'vertical-text' | 'alias' | 'copy' | 'move' | 'no-drop' | 'not-allowed' | 'grab' | 'grabbing' | 'all-scroll' | 'col-resize' | 'row-resize' | 'n-resize' | 'e-resize' | 's-resize' | 'w-resize' | 'ne-resize' | 'nw-resize' | 'se-resize' | 'sw-resize' | 'ew-resize' | 'ns-resize' | 'nesw-resize' | 'nwse-resize' | 'zoom-in' | 'zoom-out';
  animation?: 'shift-away' | 'shift-away-subtle' | 'shift-toward' | 'fade' | 'scale';
  theme?: string; // Optional theme name
  allowHTML: boolean; // Whether HTML content is allowed
  showIcon?: boolean;
  icon?: JSX.Element;
}

const InformativeTooltip: React.FC<InformativeTooltipProps> = ({
  content,
  placement = 'top',
  animation = 'fade',
  icon = <FiInfo size={18} />,
  theme = 'default-tooltip', // Default theme name
  allowHTML,
  showIcon = true,
  cursor = 'help', // Default cursor
}) => { 
  return (
    <Tippy
      content={typeof content === 'string' ? parse(content) : content}
      placement={placement}
      animation={animation}
      theme={theme}
      arrow={true}// Use the custom SVG arrow
      trigger='mouseenter focus'
      allowHTML={allowHTML}
      className="default-tooltip" // Optional custom tooltip class
    >
      {showIcon ? (
        <span style={{ cursor: 'help' }}>
          {icon ? icon : <FiInfo size={18} />}
        </span>
      ) : (
        <></>
      )}
    </Tippy>
  );
};

export default InformativeTooltip;
